module.exports = __webpack_public_path__ + "static/img/bcg.8c40f108.jpg";